module.exports = __webpack_public_path__ + "img/EKEDC.cda7679d.svg";